// extracted by mini-css-extract-plugin
export default {"catalogCard":"Catalog_catalogCard__gteiS"};